import {
  AlignmentType,
  Document,
  Header,
  HorizontalPositionRelativeFrom,
  ImageRun,
  Paragraph,
  Table,
  TableCell,
  TableRow,
} from 'docx'
import sscLogo from '@/assets/logo3.png'
import tlaxcalaLogo from '@/assets/logo2.png'
import watermarkLogo from '@/assets/watermark.png'
import BaseHeader from '../BaseHeader'
import BaseText from '../BaseText'
import BaseFooter from '../BaseFooter'

const LETTER_PAGE_SIZE = {
  width: 12240,
  height: 15840,
  orientation: 'portrait',
}

class FormatoNoAdeudoAntimotin {
  constructor({ nombre = '', puesto = '', fecha = '' } = {}) {
    const hoy = new Date().toISOString().slice(0, 10)
    this.nombre = nombre
    this.puesto = puesto
    this.fecha = fecha || hoy
  }
  get LineaEnBlanco() {
    return new Paragraph({
      children: [],
      spacing: { after: 600 },
    })
  }

  get FechaFormateada() {
    const [year, month, day] = this.fecha.split('-')
    const meses = [
      '',
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ]
    return `${parseInt(day)} del mes de ${meses[parseInt(month)]} del año ${year}`
  }

  get NumeroOficio() {
    const NUMERO_OFICIO = 'SSC/DA/****/2025.'

    return new Paragraph({
      children: [new BaseText('OFICIO NÚM: ', { bold: true }).value, new BaseText(NUMERO_OFICIO).value],
      alignment: 'end',
    })
  }

  get Asunto() {
    const ASUNTO = 'CONSTANCIA DE NO ADEUDO.'
    return new Paragraph({
      children: [new BaseText('ASUNTO: ', { bold: true }).value, new BaseText(ASUNTO).value],
      alignment: 'end',
    })
  }

  get Saludo() {
    return new Paragraph({
      children: [
        new BaseText('A QUIEN CORRESPONDA:', {
          bold: true,
        }).value,
      ],
      alignment: 'start',
    })
  }

  get Cuerpo() {
    return [
      new Paragraph({
        children: [
          new BaseText(`Por este conducto hago de su conocimiento que el C.`).value,
          new BaseText(this.nombre, { underline: true }).value,
          new BaseText(
            ', quien se identifico plenamente presentando credencial oficial vigente asi mismo quien se desempeñaba como '
          ).value,
          new BaseText(this.puesto, { underline: true }).value,
          new BaseText(', PERTENECIENTE A LA SECRETARIA DE SEGURIDAD CIUDADANA.').value,
          new BaseText(
            ' El presente documento no exime al beneficiario del mismo a cualquier otra responsabilidad que se deriven  de revisón posterior al desempeño de sus funciones, conforme lo establecido en la ley de responsabilidad de los Servidores Publicos vigente en el estado.'
          ).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
      this.LineaEnBlanco,
      new Paragraph({
        children: [new BaseText('--------------NO TIENE ADEUDO ALGUNO-----------------').value],
        alignment: AlignmentType.CENTER,
      }),
      this.LineaEnBlanco,
      new Paragraph({
        children: [
          new BaseText('Se extiende la presente constancia al dia ').value,
          new BaseText(this.FechaFormateada, { underline: true }).value,
          new BaseText(' para fines legales y/o administrativos que convengan.').value,
        ],
      }),
    ]
  }
  get Firma() {
    return [
      new Paragraph({
        children: [new BaseText('ATENTAMENTE', { bold: true }).value],
        alignment: 'center',
      }),
      this.LineaEnBlanco,
      new Paragraph({
        children: [new BaseText('ENCARGADO DEL DEPOSITO DE EQUIPO ANTIMOTIN Y BALISTICO', { bold: true }).value],
        alignment: 'center',
      }),
      new Paragraph({
        children: [new BaseText('SALVADOR AVILA TIZAPAN', { bold: true }).value],
        alignment: 'center',
      }),
    ]
  }
  async MarcaAgua() {
    const watermarkBuffer = await fetch(watermarkLogo)
      .then((r) => r.blob())
      .then((b) => b.arrayBuffer())

    return new Paragraph({
      children: [
        new ImageRun({
          data: watermarkBuffer,
          type: 'png',
          transformation: {
            width: 300,
            height: 600,
          },
          floating: {
            horizontalPosition: {
              align: 'left',
            },
            verticalPosition: {
              align: 'center',
            },
            behindDocument: true,
          },
          transparency: 0.18,
        }),
      ],
    })
  }
  async generate() {
    try {
      const sscLogoBuffer = await fetch(sscLogo)
        .then((r) => r.blob())
        .then((b) => b.arrayBuffer())

      const tlaxcalaLogoBuffer = await fetch(tlaxcalaLogo)
        .then((r) => r.blob())
        .then((b) => b.arrayBuffer())

      const marcaAgua = await this.MarcaAgua()

      const footer = await BaseFooter.generate()

      const document = new Document({
        sections: [
          {
            properties: { page: { size: { ...LETTER_PAGE_SIZE } } },
            headers: { default: new BaseHeader(sscLogoBuffer, tlaxcalaLogoBuffer) },
            children: [
              marcaAgua,
              this.NumeroOficio,
              this.Asunto,
              this.Fecha,
              this.LineaEnBlanco,
              this.Saludo,
              this.LineaEnBlanco,
              ...this.Cuerpo,
              this.LineaEnBlanco,
              ...this.Firma,
            ],
            footers: { default: footer },
          },
        ],
      })

      return document
    } catch (error) {
      console.error('Error generating ConstanciaNoAdeudo document:', error)
      throw error
    }
  }
}
export default FormatoNoAdeudoAntimotin
